export default "__VITE_ASSET__KwAqxURm__"